import { ref, reactive, onMounted, computed } from "vue";
import { has } from 'lodash-es';
import Qrcode from '@/components/common/qrCode/Qrcode';
import { getInitDownloadAPI } from '@/api';
import { promoteUrl } from "@/utils/url";
import { useStore } from 'vuex';
export default {
  name: 'PromotionPC',
  setup() {
    const state = reactive({
      appDownloadUrl: null,
      downloadBtnLarge: true,
      btnShowText: computed(() => {
        return state.downloadBtnLarge ? '收起' : '展开';
      })
    });
    const store = useStore();
    const showSiteDownload = ref(false);
    const showSiteHome = ref(false);
    const gotoHome = () => {
      window.open(promoteUrl() + '/member.php?mod=togw');
    };
    const showHome = () => {
      showSiteHome.value = true;
    };
    const hideHome = () => {
      showSiteHome.value = false;
    };
    const setLargeButton = () => {
      state.downloadBtnLarge = !state.downloadBtnLarge;
    };
    const getAppDownloadUrl = () => {
      getInitDownloadAPI({}).then(res => {
        if (has(res, 'body.url')) {
          state.appDownloadUrl = res.body.url;
        }
      });
    };
    onMounted(() => {
      // 取得APP下載URL
      getAppDownloadUrl();
    });
    return {
      state,
      showSiteDownload,
      gotoHome,
      showHome,
      hideHome,
      setLargeButton,
      store
    };
  }
};